
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/animation",
      function () {
        return require("private-next-pages/examples/animation.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/animation"])
      });
    }
  